<template>
  <div class="bottom-bar">
    <contact-store from="2" :prescriptionDetail="prescription"></contact-store>
    <div class="button-group">
      <el-button @click="$emit('close')">暂不调配</el-button>
      <el-button type="primary" @click="openSignPad">确认调配</el-button>
    </div>
    <sign-pad
      title="确认调配"
      :complete-sign-url="prescription.dispenseSignature"
      :sign-pad-visible="signPadVisible"
      @close="signPadVisible = false"
      @submit="dispensePrescription"
    />
  </div>
</template>

<script>
import Fetch from '@/api';
import contactStore from '@/components/global/contactStore/contactStore';
import signPad from './signPad';

export default {
  name: 'approveFooter',
  components: {
    contactStore,
    signPad
  },
  props: {
    prescription: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      signPadVisible: false
    };
  },
  methods: {
    openSignPad() {
      this.signPadVisible = true;
    },
    async dispensePrescription(data) {
      await Fetch.batchDispenseDispatch({ signature: data, action: 1, pid: this.prescription.id });
      this.signPadVisible = false;
      this.$emit('refresh');
      this.$emit('next', this.prescription.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.bottom-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 99;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 14px;
  width: 100%;
  height: 60px;
  background-color: #fff;
  border-top: 1px solid #efefef;
}
</style>
